import { ConfiguratedHotAlerts } from '../../components/Modals/AddSurveyModal/addSurveyInterface';
import apiFetch from '../apiFetch';
import generateHeaders from '../myHeaders';
import { buildHotAlertConfigPayload } from './createHotAlertConfig';

const updateHotAlertConfig = (
    surveyId: number,
    hotAlertConfigId: number,
    configuratedHotAlerts: ConfiguratedHotAlerts,
    selectedSchema: string,
): Promise<unknown> => apiFetch(
    `${process.env.REACT_APP_API_URL}/survey/${surveyId}/hot_alert_config/${hotAlertConfigId}`,
    { method: 'PUT', headers: generateHeaders(selectedSchema), body: JSON.stringify(buildHotAlertConfigPayload(configuratedHotAlerts)) },
);

export default updateHotAlertConfig;
